import React, { useContext } from 'react';

import classNames from 'classnames';

import { LocationContext, RouterContext } from 'common/containers/RouterContainer';
import AdminSidebarSection from 'common/subdomain/admin/AdminSidebarSection';
import styles from 'css-module/components/subdomain/admin/AdminSideBar/_CompanyFilterSection.module.scss';

import CompanyFilterInput from './CompanyFilterInput';
import CompanyFilterSelections from './CompanyFilterSelections';

const CompanyFilterSection = () => {
  const router = useContext(RouterContext);
  const location = useContext(LocationContext);

  const companySelected = (companyURLName: string) => {
    const { query } = location;
    const companiesQuery: string = location.query?.companies;
    const companiesURLNames = companiesQuery ? companiesQuery.split('_') : [];
    const companyURLNameSet: Record<string, boolean> = {};
    companiesURLNames.forEach((categoryURLName) => {
      companyURLNameSet[categoryURLName] = true;
    });

    if (companyURLNameSet[companyURLName]) {
      delete companyURLNameSet[companyURLName];
    } else {
      companyURLNameSet[companyURLName] = true;
    }

    const newURLNames = Object.keys(companyURLNameSet);
    const newCompanies = newURLNames.length > 0 ? newURLNames.join('_') : undefined;

    const newQuery = Object.assign({}, query, {
      companies: newCompanies,
    });

    router.push({
      pathname: location.pathname,
      query: newQuery,
    });
  };

  return (
    <AdminSidebarSection className={classNames(styles.companyFilterSection)} title="Companies">
      <CompanyFilterInput companySelected={companySelected} />
      <CompanyFilterSelections companySelected={companySelected} />
    </AdminSidebarSection>
  );
};

export default CompanyFilterSection;
